import { render, staticRenderFns } from "./online_purchase_list.vue?vue&type=template&id=a8036c7c&scoped=true"
import script from "./online_purchase_list.vue?vue&type=script&lang=js"
export * from "./online_purchase_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8036c7c",
  null
  
)

export default component.exports